export default __webpack_public_path__ + "static/media/PRISMA.c246a5b0.jpg";